module.exports = __webpack_public_path__ + "static/media/Murmuratto_Template_Department.cd04f864.csv";